import { ReactNode } from 'react'

import { SusdeDot } from '../components/SusdeDot'
import { TreasuriesDot } from '../components/TreasuriesDot'
import { UsdcUsdtDot } from '../components/UsdcUsdtDot'
import { CHART_COLORS } from '../constants/chart'

interface GradientConfig {
  gradient: string
  dot: ReactNode
}

export const getChartGradients = (
  dataKey: string,
  index: number,
  showGradientReferenceLine: boolean,
  strokeColors?: Record<string, string>,
) => {
  const gradientMap: Record<string, GradientConfig> = {
    'Estimated sUSDe': {
      dot: <SusdeDot />,
      gradient: 'url(#estimatedSusdeLineGradient)',
    },
    'Estimated Treasuries': {
      dot: <TreasuriesDot />,
      gradient: 'url(#estimatedTreasuriesLineGradient)',
    },
    'Estimated USDT/USDC': {
      dot: <UsdcUsdtDot />,
      gradient: 'url(#estimatedUsdtUsdcLineGradient)',
    },
    sUSDe: {
      dot: <SusdeDot />,
      gradient: 'url(#susdeLineGradient)',
    },
    Treasuries: {
      dot: <TreasuriesDot />,
      gradient: 'url(#treasuriesLineGradient)',
    },
    'USDT/USDC': {
      dot: <UsdcUsdtDot />,
      gradient: 'url(#usdtUsdcLineGradient)',
    },
  }

  const defaultColor = CHART_COLORS[index % CHART_COLORS.length]
  const strokeColor = strokeColors?.[dataKey] ?? defaultColor

  const lineStroke = showGradientReferenceLine ? gradientMap[dataKey]?.gradient || strokeColor : strokeColor

  const lineDot = gradientMap[dataKey]?.dot ?? null

  return {
    lineDot,
    lineStroke,
  }
}
